import {useSelector} from 'react-redux';

import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '../redux/selector/coach.selector';
import {userId as currentUserIdSelector} from '../redux/selector/currentUser.selector';

/**
 * Hook to get coach analytics data for referral events
 */
export const useCoachAnalyticsData = () => {
  const coachId = useSelector(currentUserIdSelector);

  const coachHighestRank = useSelector((state: any) =>
    highestAchievedRankDescriptionById(state, {coachId}),
  );

  const coachCurrentRank = useSelector((state: any) =>
    rankDescriptionById(state, {coachId}),
  );

  const lastPaidRank = useSelector((state: any) =>
    paidAsRankDescLastMonth(state, {coachId}),
  );

  return {
    coachId: String(coachId || 'na'),
    coachHighestRank: coachHighestRank || 'na',
    coachCurrentRank: coachCurrentRank || 'na',
    lastPaidRank: lastPaidRank || 'na',
  };
};

/**
 * Get referral state based on expiration status
 */
export const getReferralState = (isExpired: boolean): string => {
  return isExpired ? 'Expired' : 'Active';
};

/**
 * Get screen name for referral analytics
 */
export const getReferralScreenName = (): string => {
  return 'Referrals';
};
